<template>
  <card class="no-border-card card-ingredients mb-6" body-classes="p-0">
    <template slot="header">
      <b-row align-v="center">
        <b-col xs="12" md="5">
          <h2>{{ this.recipe.name }}</h2>
          <p>RECIPE INGREDIENTS</p>
        </b-col>

        <b-col xs="12" md="7" class="d-flex flex-wrap justify-content-end align-items-center col--filters">
          <!-- <base-button outline type="primary" v-if="estimateCostText" @click.native="showEstimateCost($event)">{{ estimateCostText }}</base-button>

          <span class="btn-estimate d-none js-btn-estimate">${{ Number(estimateCost * times).toFixed(2) }}</span> -->

          <!--div class="btn-group js-btns-select" role="group">
            <base-button type="secondary" class="active" @click.native="toggleActive($event); measureSystem = 'us'">US Customary</base-button>
            <base-button type="secondary" @click.native="toggleActive($event); measureSystem = 'metric'">Weight</base-button>
          </div-->

          <div class="btn-group js-btns-select" role="group">
            <base-button type="secondary" class="active" @click.native="times = 1; toggleActive($event)">1X</base-button>
            <base-button type="secondary" @click.native="times = 5; toggleActive($event)">5X</base-button>
            <base-button type="secondary" @click.native="times = 10; toggleActive($event)">10X</base-button>
          </div>
        </b-col>
      </b-row>
    </template>

    <el-table :data="this.recipeIngredients"
      header-row-class-name="thead-light" 
      row-key="id" 
      class="table-ingredients">

      <el-table-column label="Item" min-width="385px" prop="name">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <div class="avatar mr-3 table__avatar avatar--grey rounded-circle">
              <span v-if="row.ingredientName">{{ row.ingredientName.charAt(0) }}</span>
            </div>
            <b-media-body class="table__title-wrapper" v-if="row.subRecipe">
              <span class="font-weight-600 name mb-0 text-sm text-capitalize" v-if="row.subRecipe">{{ row.subRecipe.name }}</span>
              <span class="font-weight-600 name mb-0 text-sm text-capitalize" v-else>Missing ingredient</span>
            </b-media-body>
            <b-media-body class="table__title-wrapper" v-if="!row.subRecipe">
              <span class="font-weight-600 name mb-0 text-sm text-capitalize">{{ row.ingredientName }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Item Code" min-width="180px" prop="spec">
        <template v-slot="{ row }">
          <span class="font-weight-600 text-capitalize">{{ row.itemCode }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Specifications" min-width="180px" prop="spec">
        <template v-slot="{ row }">
          <span class="font-weight-600 text-capitalize">{{ row.spec }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Preparation" min-width="180px" prop="prep">
        <template v-slot="{ row }">
          <span class="font-weight-600 text-capitalize">{{ row.prep }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Amount/Unit" min-width="180px" prop="volume">
        <template v-slot="{row}">
          <span class="font-weight-600 text-capitalize">
            <slot v-if="measureSystem === 'us'">{{ ingredientAmt(row.volume) }}<span> {{ row.unitName }}</span></slot>
            <slot v-if="measureSystem === 'metric'">{{ row.volume }}<span> {{ row.unitName }}</span></slot>
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Grams" min-width="100px" prop="grams">
        <template v-slot="{row}">
          <span class="font-weight-600">
          <span v-if="row.grams">{{ ingredientAmt(row.grams) }}g</span>
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Uri" min-width="100px" prop="uri">
        <template v-slot="{row}">
          <span class="font-weight-600">
          <span v-if="row.uri"><a :href="safeUri(row.uri)" target="_blank"><img src="/img/icons/common/link-icon.png"/></a></span>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </card>
</template>
<script>
  import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
  import swal from 'sweetalert2';
  import n2f from 'num2fraction';


  export default {
    name: 'recipe-ingredients',
    props: {
      recipe: Object,
      ingredients: {
        type: Array,
        default: () => []
      }
    },
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu
    },
    data() {
      return {
        data: null,
        tableData: [],
        measureSystem: 'us',
        times: 1,
        estimateCost: 0
      }
    },
    computed: {
      recipeIngredients() {
        let ingredients = this.ingredients;
        return ingredients.sort((a,b) => {
          if (a.sortOrder < b.sortOrder) {
            return -1
          }
          if (a.sortOrder > b.sortOrder) {
            return 1
          }
          return 0
        })
      },
    },
    methods: {
      ingredientAmt(ingredient){
        if(ingredient == null || ingredient == '') {
          return '';
        }

        if(isNaN(ingredient)){
          return ingredient;
        }

        var decimal = Number((eval(ingredient) * this.times).toFixed(2));
        if (decimal % 1 != 0) {
          var int = Math.trunc(decimal)
          var frac = n2f(decimal - int)
          if (int != 0){
            return int + ' ' + frac
          }
          return frac
        }
        return decimal
      },
      safeUri(uri){
        if (!/^https?:\/\//i.test(uri)) {
            uri = 'http://' + uri;
        }
          return uri;
      },
      toggleActive(event) {

        this.$emit('changeNumberOfServings', this.times);

        const button = event.target;
        button.classList.add('active')

        Array.prototype.filter.call(button.parentNode.children, function(child){
          if (child !== button) {
            child.classList.remove('active')
          }
        });
      },
      showEstimateCost(event) {
        event.preventDefault();

        const button = event.target;

        document.querySelector('.js-btn-estimate').classList.remove('d-none');

        button.classList.add('d-none');
      },
      onCreated() {
      }
    },
    created(){
      this.onCreated();
    },
    mounted() {

    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
